<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()"
	*ngIf="owner && !loading">
	<div class="modal-header">
		<h4 class="modal-title">
			{{(owner.id ? 'labels.owner-edit' : 'labels.owner-create') | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<!-- `basehourlysalary` varchar(256) DEFAULT NULL,
		`daylyhrs` int(11) DEFAULT NULL, -->

		<div
			class="row"
			*ngIf="!loading && owner">
			<div class="col-sm-12">

				<div class="row">
					<!-- company -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.company' | translate }}*</label>
						<ng-template [ngIf]="companyid">
							<input
								name="companyinput"
								[placeholder]="findCompany(companyid)"
								required
								type="text"
								class="form-control"
								id="companyinput"
								disabled>
						</ng-template>
						<ng-template [ngIf]="!companyid">
							<app-entity-autocomplete
								entityName="company"
								entityField="name"
								entityFilterType="like"
								[entitySearch]="search.company"
								name="company"
								[(ngModel)]="selected.company"
								placeholder
								required
								#companyautocomp="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && companyautocomp.invalid"
								style="display: block;">
								{{'errors.required' | translate}}
							</div>

						</ng-template>
					</div>
					<!-- ownertype -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.ownertype' | translate }}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="owner.ownertype"
							required
							#ownertype="ngModel"
							name="ownertype"
							[ngClass]="{'is-invalid': editForm.submitted && ownertype.invalid}">
							<option
								*ngFor="let type of ownertypes"
								[value]="type.itemvalue">
								{{type.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && ownertype.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- mgmttypes -->
					<div class="form-group col-md-4">
						<label for="mgmttype">{{ 'labels.mgmttype' | translate }}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="owner.mgmttype"
							required
							#mgmttype="ngModel"
							name="mgmttype"
							[ngClass]="{'is-invalid': editForm.submitted && mgmttype.invalid}">
							<option
								*ngFor="let type of mgmttypes"
								[value]="type.itemvalue">
								{{type.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && ownertype.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- shares -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.shares' | translate }}*</label>
						<input
							[(ngModel)]="owner.shares"
							#shares="ngModel"
							name="shares"
							required
							type="number"
							class="form-control"
							id="shares"
							placeholder="{{ 'labels.shares' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && shares.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && shares.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- fname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.fname' | translate }}*</label>
						<input
							[(ngModel)]="owner.fname"
							#fname="ngModel"
							name="fname"
							required
							type="text"
							class="form-control"
							id="fname"
							placeholder="{{ 'labels.fname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && fname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && fname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- lname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.lname' | translate }}*</label>
						<input
							[(ngModel)]="owner.lname"
							#lname="ngModel"
							name="lname"
							required
							type="text"
							class="form-control"
							id="lname"
							placeholder="{{ 'labels.lname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && lname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && lname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- cf -->
					<div class="form-group col-md-4">
						<label for="cf">{{ 'labels.cf' | translate }}*</label>
						<input
							[(ngModel)]="owner.cf"
							#cf="ngModel"
							name="cf"
							required
							type="text"
							class="form-control"
							id="cf"
							pattern="^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$"
							placeholder="{{ 'labels.cf' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && cf.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && cf.invalid">
							{{'errors.invalid' | translate}}
						</div>
					</div>
					<!-- email -->
					<div class="form-group col-md-4">
						<label for="email">{{ 'labels.email' | translate }}*</label>
						<input
							email
							[(ngModel)]="owner.email"
							#email="ngModel"
							name="email"
							required
							type="email"
							class="form-control"
							id="email"
							placeholder="{{ 'labels.email' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && email.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && email.invalid">
							{{'errors.invalid' | translate}}
						</div>
					</div>
					<!-- mobileno -->
					<div class="form-group col-md-4">
						<label for="mobileno">{{ 'labels.mobileno' | translate }}</label>
						<input
							[(ngModel)]="owner.mobileno"
							#mobileno="ngModel"
							name="mobileno"
							type="text"
							class="form-control"
							id="mobileno"
							placeholder="{{ 'labels.mobileno' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && mobileno.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && mobileno.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- landline -->
					<div class="form-group col-md-4">
						<label for="landline">{{ 'labels.landline' | translate }}</label>
						<input
							[(ngModel)]="owner.landline"
							#landline="ngModel"
							name="landline"
							type="text"
							class="form-control"
							id="landline"
							placeholder="{{ 'labels.landline' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && landline.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && landline.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- address -->
					<div class="form-group col-md-4">
						<label>{{'labels.address' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="address"
							[(ngModel)]="owner.address"
							#address="ngModel"
							required
							[ngClass]="{'is-invalid': editForm.submitted && address.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && address.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- streetno -->
					<div class="form-group col-md-4">
						<label>{{'labels.streetno' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="streetno"
							[(ngModel)]="owner.streetno"
							#streetno="ngModel"
							required
							[ngClass]="{'is-invalid': editForm.submitted && streetno.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && streetno.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- country -->
					<div class="form-group col-md-4">
						<label>{{'labels.country' | translate}}*</label>
						<app-entity-autocomplete
							(onSelected)="updateCountry();"
							(onDeleted)="updateCountry()"
							entityName="country"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.nazione"
							[entityClass]="nazioneClass"
							name="nazione"
							[(ngModel)]="selected.nazione"
							placeholder
							required
							#country="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && notCountry}">
						</app-entity-autocomplete>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && notCountry">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- province -->
					<div class="form-group col-md-4">
						<label>{{'labels.province' | translate}}*</label>
						<ng-template [ngIf]="isItalia">
							<app-entity-autocomplete
								(onSelected)="updateProvince()"
								(onDeleted)="updateProvince()"
								entityName="province"
								entityField="descrizione"
								entityFilterType="like"
								[entitySearch]="search.provincia"
								name="provincia"
								#provinceautocomplete="ngModel"
								[(ngModel)]="selected.provincia"
								required
								placeholder
								[ngClass]="{'is-invalid': editForm.submitted && provinceautocomplete.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && provinceautocomplete.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
						<ng-template [ngIf]="!isItalia">
							<input
								[(ngModel)]="owner.province"
								[disabled]="!selected.nazione || !selected.nazione.id"
								#provinceinput="ngModel"
								name="provinceinput"
								required
								type="text"
								class="form-control"
								placeholder="{{ 'labels.province' | translate }}"
								[ngClass]="{'is-invalid': editForm.submitted && provinceinput.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && provinceinput.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>

					</div>
					<!-- city -->
					<div class="form-group col-md-4">
						<label>{{'labels.comune' | translate}}*</label>
						<ng-template [ngIf]="isItalia">
							<app-entity-autocomplete
								[disabled]="selected.provincia === undefined"
								entityName="comuni"
								entityField="descrizione"
								entityFilterType="like"
								[entitySearch]="search.comune"
								name="comune"
								[(ngModel)]="selected.comune"
								placeholder
								required
								#cityautocomplete="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && cityautocomplete.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && cityautocomplete.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
						<ng-template [ngIf]="!isItalia">
							<input
								[(ngModel)]="owner.city"
								[disabled]="!selected.nazione || !selected.nazione.id || !owner.province"
								#cityinput="ngModel"
								name="cityinput"
								required
								type="text"
								class="form-control"
								placeholder="{{ 'labels.comune' | translate }}"
								[ngClass]="{'is-invalid': editForm.submitted && cityinput.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && cityinput.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
					</div>
					<!-- birthday -->
					<div class="form-group col-md-4">
						<label>{{'labels.birthday' | translate}}*</label>
						<app-datepicker
							[(ngModel)]="owner.birthdate"
							name="birthday"
							required
							#birthday="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && birthday.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && birthday.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- birthcity -->
					<div class="form-group col-md-4">
						<label>{{'labels.birthcity' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="birthcity"
							[(ngModel)]="owner.birthcity"
							required
							#birthcity="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && birthcity.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && birthcity.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
